import type { PlanState } from '@aline/common';
import { serializeAiChatMarkdownForCopy } from '@aline/common/serializers/markdown/ai-chat-markdown';
import type { SerializeAiChatMarkdownOptions } from '@aline/common/serializers/markdown/ai-chat-markdown';
import { link } from '@aline/routes';
import { getClientPublicOrigin } from 'src/config';

import { buildFlattenedMarkdown } from '../chat-harness/useHarnessFlattenedText';

type AssistantActionMarkdownOptions = Omit<
  SerializeAiChatMarkdownOptions,
  'aiChatPath' | 'baseAppUrl' | 'omitToolCalls'
> & {
  messageText: string;
  planState?: PlanState;
};

export async function getAssistantActionMarkdown({
  assistantMessageRunning,
  messageId,
  messageText,
  planState,
  playbookRunArtifacts,
  processingToolCallIds,
  taskArtifacts,
  threadId,
  uiParts,
  workflowArtifacts,
  workflowTemplateArtifacts,
}: AssistantActionMarkdownOptions) {
  const rawMarkdown = planState ? buildFlattenedMarkdown(planState) : messageText;
  return serializeAiChatMarkdownForCopy(rawMarkdown, {
    aiChatPath: typeof window === 'undefined' ? link.ChatIndex() : window.location.pathname,
    assistantMessageRunning,
    baseAppUrl: getClientPublicOrigin(),
    messageId,
    omitToolCalls: false,
    playbookRunArtifacts,
    processingToolCallIds,
    taskArtifacts,
    threadId,
    uiParts,
    workflowArtifacts,
    workflowTemplateArtifacts,
  });
}
